import { render, staticRenderFns } from "./OilTrackerByOilList.vue?vue&type=template&id=2ab107d4&scoped=true"
import script from "./OilTrackerByOilList.vue?vue&type=script&lang=js"
export * from "./OilTrackerByOilList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab107d4",
  null
  
)

export default component.exports